import { render } from "./Report.vue?vue&type=template&id=354f26a8"
import script from "./Report.vue?vue&type=script&lang=js"
export * from "./Report.vue?vue&type=script&lang=js"
script.render = render

export default script